var exports = {
  "zr": "x93eb46d8--499c5f--root",
  "jD": "x93eb46d8--499c5f--breadcrumbs",
  "Zo": "x93eb46d8--499c5f--seo-tabs-links",
  "R_": "x93eb46d8--499c5f--heading",
  "ne": "x93eb46d8--499c5f--controls",
};

module.exports = exports;
